import { useState } from "react";
import { Link } from "react-router-dom";

import { hasClerk } from "../auth/clerk";
import { useGame } from "../game/GameContext";
import ReportProblemModal from "./ReportProblemModal";
import RestartModal from "./RestartModal";
import SignOutButton from "./SignOutButton";

export default function Header() {
  const { worldTitle, locationName, ambientMuted, toggleAmbient, restart, restarting, turn, sessionId } = useGame();
  const [showRestart, setShowRestart] = useState(false);
  const [showReport, setShowReport] = useState(false);

  return (
    <>
      <header id="header">
        <div id="header-left">
          <Link
            id="home-link"
            to="/"
            title="Back to home"
            aria-label="Back to home"
          >
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M3 12 12 3l9 9" />
              <path d="M5 10v10h14V10" />
            </svg>
          </Link>
          <span id="game-title">{worldTitle}</span>
          {locationName && <span id="location-name">{locationName}</span>}
        </div>
        <div id="header-right">
          <button
            id="restart-btn"
            title={restarting ? "Starting a new adventure…" : "Start a new adventure"}
            aria-label={restarting ? "Starting a new adventure" : "Start a new adventure"}
            aria-busy={restarting}
            disabled={restarting}
            onClick={() => setShowRestart(true)}
          >
            {/* Issue #588: spin the icon while the bootstrap narration
                is in flight (~10s) so the click registers visibly. */}
            <svg
              width="18"
              height="18"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className={restarting ? "restart-spinner" : undefined}
            >
              <polyline points="1 4 1 10 7 10" />
              <path d="M3.51 15a9 9 0 1 0 2.13-9.36L1 10" />
            </svg>
          </button>

          <button
            id="sound-toggle"
            title="Toggle ambient sound"
            aria-label="Toggle ambient sound"
            className={ambientMuted ? "" : "active"}
            onClick={toggleAmbient}
          >
            {ambientMuted ? (
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5" />
                <line x1="23" y1="9" x2="17" y2="15" />
                <line x1="17" y1="9" x2="23" y2="15" />
              </svg>
            ) : (
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5" />
                <path d="M19.07 4.93a10 10 0 0 1 0 14.14" />
                <path d="M15.54 8.46a5 5 0 0 1 0 7.07" />
              </svg>
            )}
          </button>

          <button
            id="report-btn"
            title={sessionId ? "Report a problem" : "Report a problem (available once your session loads)"}
            aria-label="Report a problem"
            onClick={() => setShowReport(true)}
            disabled={!sessionId}
          >
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M4 21V4" />
              <path d="M4 4h12l-2 4 2 4H4" />
            </svg>
          </button>

          {hasClerk() && <SignOutButton />}
        </div>
      </header>

      {showRestart && (
        <RestartModal
          onCancel={() => setShowRestart(false)}
          onConfirm={async () => {
            setShowRestart(false);
            await restart();
          }}
        />
      )}

      {showReport && (
        <ReportProblemModal
          sessionId={sessionId}
          turn={turn}
          onClose={() => setShowReport(false)}
        />
      )}
    </>
  );
}
